import { CheckIcon } from '@heroicons/react/16/solid';

import { Tag } from '../ui';

const QUOTE_STATUS_COLORS = {
  ordered: 'flat',
  not_purchased: 'no_action'
} as const;

const QUOTE_STATUS_LABEL = {
  ordered: 'Ordered',
  not_purchased: 'Not purchased'
} as const;

interface QuoteStatusTagProps {
  quote: any;
}

const QuoteStatusTag: React.FC<QuoteStatusTagProps> = ({ quote }) => {
  const type =
    quote?.sample_payment_status === 'completed' ? 'ordered' : 'not_purchased';

  const renderIcon = () => {
    if (type === 'ordered') {
      return <CheckIcon className="size-4" />;
    }

    return null;
  };

  return (
    <Tag
      as="div"
      className="capitalize"
      color={QUOTE_STATUS_COLORS[type] || 'no_action'}
    >
      <div className="flex items-center justify-center gap-1">
        {renderIcon()} {QUOTE_STATUS_LABEL[type] || 'Not purchased'}
      </div>
    </Tag>
  );
};

export default QuoteStatusTag;
